<template lang="pug">
div.wrap-item-asset-favorite
  v-icon(@click.stop="onFavorite"
    :color="isFavoriteAsset ? pallete.$favorite_color : pallete.$deactive_color"
    size="28px").mr4 {{isFavoriteAsset ? 'mdi-star' : 'mdi-star-outline'}}
  //- v-icon(@click.stop="onFavorite"
    :color="isFavoriteAsset ? pallete.$like_color : pallete.$deactive_color"
    size="28px").mr4 {{isFavoriteAsset ? 'mdi-heart' : 'mdi-heart-outline'}}
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.wrap-item-asset-favorite {
}
</style>

<script>
import database from '@/database'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth } = createNamespacedHelpers('auth')

export default {
  props: {
    asset: {
      type: Object,
      required: true
    },
    me: {
      type: Object,
      default: null
    }
  },
  computed: {
    ...mapStateAuth(['uid'])
  },
  watch: {
    me: {
      handler () {
        if (this.me) this.isFavoriteAsset = this.me.favoriteAssets.includes(this.asset.id)
      },
      deep: true
    }
  },
  data () {
    return {
      isFavoriteAsset: false
    }
  },
  async created () {
    if (this.me) this.isFavoriteAsset = this.me.favoriteAssets.includes(this.asset.id)
  },
  methods: {
    async onFavorite () {
      if (this.isSaving) return
      this.isSaving = true

      if (!this.me) {
        const redirectPath = encodeURIComponent(this.$route.path)
        this.$root.$emit('showNavigationMessage', {
          message: 'アセットをお気に入りに追加するにはログインする必要があります',
          to: `/sign-in/${redirectPath}`,
          showOK: true
        })
        return
      }

      const favoriteRef = database.userFavoriteAssetCollection(this.uid)

      if (this.isFavoriteAsset) {
        this.isFavoriteAsset = false
        await favoriteRef.delete(this.asset.id)
        await database.userCollection()
          .deleteFavoriteAsset({ uid: this.uid, assetId: this.asset.id })
      } else {
        this.isFavoriteAsset = true
        const favoriteObj = {
          assetId: this.asset.id,
          assetCreatedBy: this.asset.createdBy,
          createdBy: this.uid,
          createdAt: new Date()
        }
        await favoriteRef.set(this.asset.id, favoriteObj)
        await database.userCollection()
          .addFavoriteAsset({ uid: this.uid, assetId: this.asset.id })
      }

      await this.sleep(400)
      this.isSaving = false
    }
  }
}
</script>
